import myList from './myList.vue';
import allList from './allList.vue';
import { claimsList, groupInsurancePack } from './request';
export default {
  components: {
    myList,
    allList
  },
  data() {
    return {
      current: 1,
      num: 0,
      examineListData: [],
      form: {
        auditFlowDetailIds: []
      },
      showVisible: false,
      loading: false
    };
  },
  created() {
    this.getNumFun();
  },
  methods: {
    getNumFun() {
      claimsList({
        page: 1,
        pageSize: 1,
        status: 'PENDING',
        type: 'groupInsuranceCheckPending'
      }).then(res => {
        this.num = (res === null || res === void 0 ? void 0 : res.totalNum) || 0;
      });
    },
    sendEmail() {
      this.showVisible = true;
      this.form.auditFlowDetailIds = [];
      this.loading = false;
      claimsList({
        page: 1,
        pageSize: this.num || 1,
        status: 'PENDING',
        type: 'groupInsuranceSendMail'
      }).then(res => {
        this.examineListData = res.items;
      });
    },
    okSubmit() {
      let params = {
        auditFlowDetailIds: this.form.auditFlowDetailIds.join(',')
      };
      this.loading = true;
      groupInsurancePack(params).then(res => {
        this.$message.success('发送成功');
        this.showVisible = false;
        this.examineListData = [];
        this.form.auditFlowDetailIds = [];
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};